import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchCompetition = () => api.get("/competition").then((r) => r.data);
export const fetchTraders = () => api.get("/traders").then((r) => r.data);
export const fetchTrader = (id) => api.get(`/traders/${id}`).then((r) => r.data);
export const fetchTrades = (limit = 30) => api.get(`/trades?limit=${limit}`).then((r) => r.data);
export const fetchSnapshots = () => api.get("/snapshots").then((r) => r.data);
export const fetchStocks = () => api.get("/stocks").then((r) => r.data);
export const fetchRecaps = (limit = 5) => api.get(`/recaps?limit=${limit}`).then((r) => r.data);
export const generateRecap = () => api.post("/recaps/generate").then((r) => r.data);
export const runRound = () => api.post("/round/run").then((r) => r.data);
export const resetCompetition = () => api.post("/competition/reset").then((r) => r.data);
